const fontAwesomePromises = new Map();

const FAMILY_STYLES = Object.freeze({
  solid: ['solid'],
  fas: ['solid'],
  regular: ['regular'],
  far: ['regular'],
  light: ['regular'],
  fal: ['regular'],
  brands: ['brands'],
  fab: ['brands'],
  duo: ['solid'],
});

const STYLE_LOADERS = Object.freeze({
  solid: () => import('@fortawesome/fontawesome-free/css/solid.min.css'),
  regular: () => import('@fortawesome/fontawesome-free/css/regular.min.css'),
  brands: () => import('@fortawesome/fontawesome-free/css/brands.min.css'),
});

const normalizeFamilies = (family) => {
  if (!family) return ['solid', 'regular', 'brands'];
  const values = Array.isArray(family) ? family : [family];
  const normalized = values.flatMap((value) => FAMILY_STYLES[String(value || '').trim().toLowerCase()] || []);
  return normalized.length > 0 ? [...new Set(normalized)] : ['solid', 'regular', 'brands'];
};

export function ensureFontAwesome(family) {
  const styles = normalizeFamilies(family);
  const key = styles.join(',');
  if (!fontAwesomePromises.has(key)) {
    fontAwesomePromises.set(key, Promise.all([
      import('@fortawesome/fontawesome-free/css/fontawesome.min.css'),
      ...styles.map((style) => STYLE_LOADERS[style]()),
    ]).catch((error) => {
      fontAwesomePromises.delete(key);
      throw error;
    }));
  }

  return fontAwesomePromises.get(key);
}
